import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取浏览器记录
    GetMemorialHallVisitCallerList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/VisitCaller/GetMemorialHallVisitCallerList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}